import {LINKER_PAYLOAD_LEAVING_GROUP_MALFORMED_ERROR} from 'molbio/adcs/linker-payload-connection/AdcLinkerPayloadLeavingGroupConstants';
import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';

/**
 * Display label for a leaving group by its number, e.g. "LG1", matching complex polymer attachments; this is
 * also the text stored in a Linker-payload leaving group cell.
 */
export function formatLeavingGroup(leavingGroup: number): string {
  return `LG${leavingGroup}`;
}

const LEAVING_GROUP_PATTERN = /^LG([1-9]\d*)$/;

/**
 * A parsed Linker-payload leaving group cell: its leaving group's number, null for an empty cell, or an error
 * for text that is not a leaving group label.
 */
export type ParsedLeavingGroup = {leavingGroup: number | null} | {error: string};

const MALFORMED: ParsedLeavingGroup = {error: LINKER_PAYLOAD_LEAVING_GROUP_MALFORMED_ERROR};

/** Parses the text stored in a Linker-payload leaving group cell, which may be hand-typed or pasted. */
export function parseLeavingGroup(text: string): ParsedLeavingGroup {
  const trimmed = text.trim();
  if (trimmed === '') {
    return {leavingGroup: null};
  }
  const match = LEAVING_GROUP_PATTERN.exec(trimmed);
  const leavingGroup = match != null ? Number(match[1]) : null;
  // Numbers too large to represent exactly would format back to a different label.
  return leavingGroup != null && Number.isSafeInteger(leavingGroup) ? {leavingGroup} : MALFORMED;
}

/** Parses a Linker-payload leaving group cell's typed value; see {@link parseLeavingGroup}. */
export function parseLeavingGroupTypedValue(typedValue: TypedValue | null | undefined): ParsedLeavingGroup {
  if (typedValue == null) {
    return {leavingGroup: null};
  }
  return typedValue.type === BaseTypedValueType.STRING ? parseLeavingGroup(typedValue.rawValue) : MALFORMED;
}
